import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import Routes from './routes'

export const bus = new Vue();

Vue.use(VueRouter);

// Register routes
const router = new VueRouter({
    routes: Routes,
    mode: 'hash'
});

Vue.config.productionTip = false

Vue.use(VueResource);

new Vue({
  render: h => h(App),
  router: router
}).$mount('#app')
